module.exports = __webpack_public_path__ + "img/point5.bf626ae7.png";